import { useEffect } from 'react';
import compose from 'recompose/compose';

import { useStore } from 'store';
import { withAgentPage, withLayout } from 'hocs';
import { SEARS_PRODUCT, TOTAL_GIFT_TABLES } from 'constants/storage64';
import { decodeStorage, encodeStorage, removeStorage } from 'functions/storageBase64';
import { fetchMyGiftsTables } from 'store/actions/giftTable';
import {
  showLoader,
  hideLoader
} from 'store/actions/commons';

import { PROJECT_BASENAME } from 'constants/env';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const TableByPass = () => {

  const [, dispatch] = useStore((state) => state.giftTable.giftTable);

  useEffect(async () => {
    try {
      dispatch(showLoader());
      await dispatch(
        fetchMyGiftsTables({
          withLoader: Boolean(true),
          withModalError: Boolean(false)
        })
      );

      //      ESPERA 3 SEG PARA QUE SE CARGUEN LAS MESAS DE REGALO
      await sleep(3000);

      const savedUrl = decodeStorage(SEARS_PRODUCT);
      const total_gift_tables = decodeStorage(TOTAL_GIFT_TABLES);
      //  console.log('total_gift_tables', total_gift_tables);

      dispatch(hideLoader());
      if(savedUrl && savedUrl.length) {
        encodeStorage('isByPass', true);
        removeStorage('isChangedGiftTable');
          console.log('total_gift_tables', total_gift_tables);
        window.location.href = +total_gift_tables
          ? `${PROJECT_BASENAME}agregar-regalos`
          : `${PROJECT_BASENAME}crear-mesa`;
      }
    } catch (error) {
      // Manejar errores en caso de que fetchMyGiftsTables falle
      console.error('Error al obtener las mesas de regalos:', error);
    }
  }, []);

  return (
    <>
      <div className="mb-5 h-100" style={{minHeight: 500}}></div>
    </>
  );
};

export default compose(
  withLayout,
  withAgentPage(),
)(TableByPass);
